'use client';

import type { Stance } from '@/platform/forum/api';
import '@/platform/forum/forum-actions.css';

export type StanceReactionButtonsProps = {
  myStance?: Stance | null;
  disabled?: boolean;
  agreeTitle?: string;
  disagreeTitle?: string;
  agreeLabel?: string;
  disagreeLabel?: string;
  onReact: (stance: Stance) => void | Promise<void>;
  /** Optional test id prefix, e.g. comment id */
  testIdPrefix?: string;
};

/** Shared agree/disagree thumbs used by forum comments and haul validity votes. */
export function StanceReactionButtons({
  myStance,
  disabled,
  agreeTitle = 'Agree',
  disagreeTitle = 'Disagree',
  agreeLabel = 'Agree',
  disagreeLabel = 'Disagree',
  onReact,
  testIdPrefix,
}: StanceReactionButtonsProps) {
  return (
    <>
      <button
        type="button"
        disabled={disabled}
        className={`post-actions__icon-btn${myStance === 'agree' ? ' post-actions__icon-btn--active' : ''}`}
        title={agreeTitle}
        aria-label={agreeLabel}
        data-testid={testIdPrefix ? `${testIdPrefix}-stance-agree` : undefined}
        onClick={() => void onReact('agree')}
      >
        <i className="uil uil-thumbs-up" aria-hidden />
      </button>
      <button
        type="button"
        disabled={disabled}
        className={`post-actions__icon-btn${myStance === 'disagree' ? ' post-actions__icon-btn--active' : ''}`}
        title={disagreeTitle}
        aria-label={disagreeLabel}
        data-testid={testIdPrefix ? `${testIdPrefix}-stance-disagree` : undefined}
        onClick={() => void onReact('disagree')}
      >
        <i className="uil uil-thumbs-down" aria-hidden />
      </button>
    </>
  );
}
